<template>
  <div class="payment-status">
    <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
      <p>Verifying your payment, please wait...</p>
    </div>
  </div>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";

export default {
  data() {
    return {
      loading: false,
    };
  },
  async mounted() {
    const orderId = this.$route.query.order_id || this.$route.params.order_id;
    // const isBBPS = this.$route.query.type === "bbps";
console.log("orderId//////////////////",orderId);

    if (!orderId) {
      this.$refs.toast.show("Missing order ID", "error");
      return;
    }

    this.loading = true;

   
      await this.verifyBBPSPaymentStatus(orderId);
    
  },
  methods: {
    async verifyBBPSPaymentStatus(orderId) {
      try {
        console.log("verifyBBPSPaymentStatus");
        
        const response = await NetworkService.post(`get-cashfree-bill-payment-status/${orderId}`);

        // Assuming response.data contains the data
        console.log("✅ BBPS payment status response:", response);

      const success = response.data?.status; // boolean true/false
const message = response.data?.message || "";

if (success === true) {
  // success case
  this.$refs.toast.show(message || "Payment successful", "success");
  setTimeout(() => {
    this.loading = false;
    this.$router.push({ name: "ThankYou" });
  }, 2000);
} else if (success === false) {
  // failure case
  this.$refs.toast.show(message || "Payment failed", "error");
  setTimeout(() => {
    this.loading = false;
    this.$router.push({ name: "OurServices" });
  }, 3000);
} else {
  // unknown status (optional fallback)
  this.$refs.toast.show("Unexpected payment status", "error");
  this.loading = false;
}

      } catch (error) {
        this.$refs.toast.show("Unable to verify payment", "error");
        setTimeout(() => {
          this.loading = false;
          this.$router.push({ name: "OurServices" });
        }, 3000);
      }
    },


  },
};
</script>

<style scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
